import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaToolbarTitle = styled(Flexbox)(
    ({theme: {typography, palette}}) => css`
        font-size: ${typography.textLg};
        font-weight: 500;

        & > p {
            font-size: ${typography.textSm};
            font-weight: 400;
            color: ${palette.neutral[500]};
        }
    `
)
